import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchEndpointIfNeeded } from '../../actions/fetch'

const ReferenceDropdown = ({
    valueName,
    endpointName,
    endpoints,
    dispatch,
    onChange,
    value,
    id,
    name,
    className,
    showInactive,
    disabled,
    fallBackToText
}) => {
    let selectDom = null
    let finalFallBackToText = fallBackToText !== undefined ? fallBackToText : true

    let epList = []


    let foundEndpoint = endpoints.find(elem =>
        elem.name === endpointName
    )

    if (foundEndpoint) {
        if (foundEndpoint.list.length === 0) {
            dispatch(fetchEndpointIfNeeded(foundEndpoint.id))
        }
        if (foundEndpoint.list.length > 0) {
            epList = foundEndpoint.list
                .filter(fep => {
                    if (showInactive === false && (fep.hasOwnProperty('status') && !fep.status)) {
                        // do not include in the options if endpoint has status field and it is set to 0 or false
                        return false
                    } else {
                        return true
                    }
                })
                .map(fep => {
                    return {
                        id: fep.id,
                        name: fep.name || fep.description || fep.id,
                        status: fep.status
                    }
                })
        }
        
    }
    if (value === null) {
        value = ""
    }

    let test = epList.find(ep => ep.id === Number(value))
    let currentValueIsUnknown = false
    let isInactive = false
    let InactiveTask = ''
    if (value && epList.length > 0) {
        let currentValSelected = epList.find(ep => ep.id === Number(value))
        if (currentValSelected) {
            if (currentValSelected.status === 0) {
                isInactive = true
                InactiveTask = currentValSelected.name
            }
        }
        if (!currentValSelected) {
            currentValueIsUnknown = true
        }
    }

    // Create the drop down.
    if (epList.length > 0) {
        selectDom = <select disabled={disabled} value={value} onChange={onChange} id={id} name={name} className={className || "form-control"} >
            <option value="">Select from {endpointName}</option>
            {
                epList.map(epl => epl.status === 0 ? <option key={epl.id} value={epl.id}>(INACTIVE){epl.name}</option> : <option key={epl.id} value={epl.id}>{epl.name}</option>)
            }
            {/* {isInactive &&
                <option value={value}> (INACTIVE) {InactiveTask}</option>
            } */}

        </select>
    } else {
        if (finalFallBackToText) {
            selectDom = <input
                disabled={disabled}
                type="text"
                id={id}
                className={className || "form-control"}
                value={value}
                onChange={onChange} />
        } else {
            selectDom = (
                <select disabled={disabled} value={value} onChange={onChange} id={id} name={name} className={className || "form-control"} >
                    <option value="">No {endpointName} available</option>
                    {value &&
                        <option value={value}>INACTIVE ({value})</option>
                    }
                </select>
            )
        }
    }

    return selectDom
}

function mapStateToProps(state, ownProps) {
    // default to false if not specified
    let showInactive = ownProps.hasOwnProperty("showInactive") ? ownProps.showInactive : false

    return {
        endpoints: state.endpoints,
        onChange: ownProps.onChange,
        endpointName: ownProps.endpointName,
        value: ownProps.value,
        id: ownProps.id,
        name: ownProps.name,
        showInactive
    }
}

export default withRouter(connect(mapStateToProps)(ReferenceDropdown))


// WEBPACK FOOTER //
// ./src/components/utilities/ReferenceDropdown.js